var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h5-login" }, [
    _c(
      "div",
      { staticClass: "h5-login-box" },
      [
        _c("a-icon", {
          staticStyle: { "font-size": "48px", color: "#1890ff" },
          attrs: { type: "shop" },
        }),
        _c("h2", [_vm._v("收单系统")]),
        _c("p", { staticClass: "tip" }, [_vm._v(_vm._s(_vm.tip))]),
        _c(
          "a-button",
          {
            attrs: {
              type: "primary",
              block: "",
              size: "large",
              loading: _vm.loading,
            },
            on: { click: _vm.startAuth },
          },
          [_vm._v("微信授权登录")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }